/* eslint-disable complexity */
import 'regenerator-runtime/runtime.js';
import React, { useEffect, Suspense } from 'react';
import cls from 'classnames'
import { Switch, Route, Router, useLocation } from 'react-router-dom';
import { PortalUIProvider } from '@portal-site/components';
import Header from './common/Header';
// import SideBar from './common/SideBar';
import Footer from './common/Footer';
import { pcRoutes, history } from './routes';
import 'normalize.css';
import ErrorCatch from '../components/ErrorCatch';
import 'viewerjs/dist/viewer.min.css';
import { renderRoutes } from 'react-router-config';
import { getUserInfo } from './common/LoginModal/store';
import { useDispatch } from 'react-redux';
import Loading from '../components/Loading';
import defaultImg from '@/assets/images/default.jpg';

const ENV_IMG_PREURL = window.ENV_IMG_PREURL;

const Main = () => {
  const { pathname } = useLocation()

  const isIndex = pathname === '/';
  const issearch = pathname.includes('PicturelistPage');
  const isInstancesDetail = (pathname.includes('Subject') && pathname.split('/').length === 4)

  // 不需要底部在这加条件
  const nofooter = (pathname.includes('PicturelistPage') && pathname.split('/').length >= 3) || pathname.includes('Relation')
  // 不要顶部
  // const noheader = (pathname.includes('PicturelistPage') && pathname.split('/').length >= 3)
  const noheader = false;
  // 不需要侧边栏
  // const noslidebar = (pathname.includes('PicturelistPage') && pathname.split('/').length >= 3)
  return (
    <div className={cls("main-cont", { 'index-page': isIndex })}>
      {!noheader && <Header />}
      {/* {!noslidebar && <SideBar isIndex={isIndex} />} */}
      {isIndex || issearch ? (
        <Suspense fallback={<Loading />}>{renderRoutes(pcRoutes)}</Suspense>
      ) : (
        <div className={cls("inner-cont", { "inner": pathname.includes('PersonalPage') || pathname.includes('Refenrences') || isInstancesDetail || pathname.includes('KnowledgeSearch'), 'personal-inner': pathname.includes('PersonalPage') })}>
          <Suspense fallback={<Loading />}>{renderRoutes(pcRoutes)}</Suspense>
        </div>
      )}

      {!nofooter && <Footer />}
    </div>
  );
};

const App = ({ children }) => {
  return (
    <PortalUIProvider
      value={{
        assetsPrefix: ENV_IMG_PREURL,
        pictureFallback: defaultImg
      }}
    >
      <ErrorCatch>
        <Page />
      </ErrorCatch>
    </PortalUIProvider>
  );
};
const Page = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    // 刷新之后重新获取用户
    dispatch(getUserInfo());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Router history={history}>
      <Switch>
        <Route path="/" component={Main} />
      </Switch>
    </Router>
  );
};
export default App;
